const formOptions = {
  formOptionsIncomeOtherPaymentType: [
    {
      label: 'Earnings/Pension/Benefits direct to this account',
      value: 'EARNINGS DIRECT TO ACCOUNT',
    },
    {
      label: 'Rental/Dividends/Other income direct to this account',
      value: 'OTHER DIRECT TO ACCOUNT',
    },
    { label: 'Cash', value: 'CASH' },
    { label: 'Cheque', value: 'CHEQUE' },
    {
      label: 'Transfer from my account at another Bank',
      value: 'TRANSFER FROM OTHER BANK',
    },
    {
      label: 'Transfer from another family member',
      value: 'TRANSFER FROM FAMILY',
    },
    {
      label: 'Transfer from another of my Clydesdale or Yorkshire accounts',
      value: 'TRANSFER FROM OTHER NAG ACCOUNT',
    },
  ],
  formOptionsAccountPurpose: [
    {
      label: 'Main account receiving income',
      value: 'MAIN ACCOUNT RECEIVING INCOME',
    },
    {
      label: 'Account to service regular bills',
      value: 'ACCOUNT TO SERVICE REGULAR BILLS',
    },
    {
      label: 'Account for spending money',
      value: 'ACCOUNT FOR SPENDING MONEY',
    },
    { label: 'Savings', value: 'SAVINGS' },
  ],
  formOptionsSavingsAccountPurpose: [
    {
      label: 'Account to service regular bills',
      value: 'ACCOUNT TO SERVICE REGULAR BILLS',
    },
    {
      label: 'Account for spending money',
      value: 'ACCOUNT FOR SPENDING MONEY',
    },
    { label: 'Savings', value: 'SAVINGS' },
  ],
  formOptionsResidentialStatus: [
    { label: 'Owner', value: 'OWNER' },
    { label: 'Tenant Private', value: 'TENANT PRIVATE' },
    { label: 'Tenant Public', value: 'TENANT PUBLIC' },
    { label: 'Living with Parents', value: 'LIVING WITH PARENTS' },
    { label: 'Living with Friends', value: 'LIVING WITH FRIENDS' },
    { label: 'Leasehold', value: 'LEASEHOLD' },
  ],
  formOptionsMaritalStatus: [
    { label: 'Single', value: 'SINGLE' },
    { label: 'Living common law with partner', value: 'PARTNER' },
    {
      label: 'Married / Civil partnership',
      value: 'MARRIED / CIVIL PARTNERSHIP',
    },
    { label: 'Divorced', value: 'DIVORCED' },
    { label: 'Separated', value: 'SEPARATED' },
    { label: 'Widowed', value: 'WIDOWED' },
  ],
  formOptionsEmploymentStatus: [
    { label: 'Full time', value: 'FULL TIME', behaviour: 'active' },
    { label: 'Part time', value: 'PART TIME', behaviour: 'active' },
    { label: 'Agency contract', value: 'AGENCY CONTRACT', behaviour: 'active' },
    {
      label: 'Fixed term contract',
      value: 'FIXED TERM CONTRACT',
      behaviour: 'active',
    },
    { label: 'Self employed', value: 'SELF EMPLOYED', behaviour: 'active' },
    { label: 'Retired', value: 'RETIRED', behaviour: 'inactive' },
    { label: 'Student', value: 'STUDENT', behaviour: 'inactive' },
    { label: 'House Person', value: 'HOUSE PERSON', behaviour: 'inactive' },
    {
      label: 'Long term disabled',
      value: 'LONG TERM DISABLED',
      behaviour: 'inactive',
    },
    { label: 'Unemployed', value: 'UNEMPLOYED', behaviour: 'inactive' },
  ],
  formOptionsOccupation: [
    { label: 'Armed Forces', value: 'ARMED FORCES' },
    {
      label: 'Junior Non Manual Clerical',
      value: 'JUNIOR NON MANUAL CLERICAL',
    },
    { label: 'Junior Sales', value: 'JUNIOR SALES' },
    { label: 'Managerial', value: 'MANAGERIAL' },
    { label: 'Professional With Degree', value: 'PROFESSIONAL WITH DEGREE' },
    {
      label: 'Professional Without Degree',
      value: 'PROFESSIONAL WITHOUT DEGREE',
    },
    { label: 'Self Employed', value: 'SELF EMPLOYED' },
    { label: 'Senior Manual', value: 'SENIOR MANUAL' },
    { label: 'Services', value: 'SERVICES' },
    { label: 'Skilled Manual', value: 'SKILLED MANUAL' },
    {
      label: 'Senior Non Manual Clerical',
      value: 'SENIOR NON MANUAL CLERICAL',
    },
    { label: 'Senior Sales', value: 'SENIOR SALES' },
    { label: 'Semi Skilled Manual', value: 'SEMI SKILLED MANUAL' },
    { label: 'Unskilled Manual', value: 'UNSKILLED MANUAL' },
  ],
  formOptionsPreferredContactMethod: [
    { label: 'Email', value: 'EMAIL' },
    { label: 'SMS', value: 'SMS' },
    { label: 'Phone', value: 'PHONE' },
    { label: 'Post', value: 'MAIL' },
  ],
  formOptionsOtherIncomeFrequency: [
    { label: 'Weekly', value: 'WEEKLY' },
    { label: 'Fortnightly', value: 'FORTNIGHTLY' },
    { label: 'Monthly', value: 'MONTHLY' },
    { label: 'Annually', value: 'ANNUAL' },
  ],
  formOptionsSavingsFrequency: [
    { label: 'Weekly', value: 'WEEKLY' },
    { label: 'Fortnightly', value: 'FORTNIGHTLY' },
    { label: 'Monthly', value: 'MONTHLY' },
    { label: 'Annually', value: 'ANNUAL' },
  ],
  validTitles: [
    { label: 'Mr', value: 'Mr', gender: 'Male' },
    { label: 'Mrs', value: 'Mrs', gender: 'Female' },
    { label: 'Miss', value: 'Miss', gender: 'Female' },
    { label: 'Ms', value: 'Ms', gender: 'Female' },
    { label: 'Master', value: 'Master', gender: 'Male' },
    { label: 'Dr', value: 'Dr', gender: null },
    { label: 'Lady', value: 'Lady', gender: null },
    { label: 'Lord', value: 'Lord', gender: null },
    { label: 'Prof', value: 'Prof', gender: null },
    { label: 'Rev', value: 'Rev', gender: null },
    { label: 'Sir', value: 'Sir', gender: null },
  ],
  existingCustomerReadOnlyFields: [
    'title',
    'firstName',
    'hasMiddleName',
    'lastName',
    'dateOfBirth',
    'gender',
    'phoneNumber',
    'addresses',
  ],
};

export default formOptions;
